import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const FormWrapper = styled.div`
	width: 1000px;
	display: grid;
	gap: 40px;
`;

export const Title = styled.h3`
	color: ${Colors.darkBlue};
`;

export const Flex = styled.div`
	display: flex;
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	width: 100%;
	justify-content: right;
	margin-top: -40px;
	gap: 30px;
`;

export const AddressDetails = styled.div`
	border: 1px #010b7760 solid;
	border-radius: 8px;
	padding: 8px;
	margin-bottom: 16px;
	margin-left: 32px;
`;
